import React from 'react';
import Header from '@/core/presentation/components/Header';
import Footer from '@/core/presentation/components/Footer';
import HeroSection from './components/HeroSection';
import MarqueeSection from './components/MarqueeSection';
import ProblemSection from './components/ProblemSection';
import HowItWorksSection from './components/HowItWorksSection';
import PlansSection from './components/PlansSection';
import BenefitsSection from './components/BenefitsSection';
import ResultsCalculator from './components/ResultsCalculator';
// import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import StructuredDataScript from './components/StructuredDataScript';

export default function HomePage() {
  return (
    <>
      {/* Noise overlay for premium feel */}
      <div className="noise-overlay" aria-hidden="true" />

      <Header />

      <main>
        {/* Hero: New positioning — system reminds the owner */}
        <HeroSection />

        {/* Marquee: scrolling keywords */}
        <MarqueeSection />

        {/* Problem: Pain points — forgetting clients, losing revenue */}
        <ProblemSection />

        {/* Calculator: client base, avg value, return % → recovered clients & turnover */}
        <ResultsCalculator />

        {/* How it works: 3-step owner flow */}
        <HowItWorksSection />

        {/* Planos: mesma vitrine base da escolha de plano (sem checkout na landing) */}
        <PlansSection />

        {/* Benefits: Organization, predictability, revenue, control */}
        <BenefitsSection />

        

        {/* Testimonials: who uses, doesn't go back */}
        {/* <TestimonialsSection /> */}

        {/* FAQ: Common doubts about the new positioning */}
        <FAQSection />

      </main>

      <Footer />

      {/* JSON-LD injetado só no client para evitar hydration mismatch no mobile */}
      <StructuredDataScript />
    </>
  );
}